/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reply_In_ThreadInputs */

const en_reply_in_thread = /** @type {(inputs: Reply_In_ThreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply in thread...`)
};

const id_reply_in_thread = /** @type {(inputs: Reply_In_ThreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balas di dalam utas...`)
};

/** @type {(inputs: Reply_In_ThreadInputs) => LocalizedString} */
const es_reply_in_thread = en_reply_in_thread;

/** @type {(inputs: Reply_In_ThreadInputs) => LocalizedString} */
const fr_reply_in_thread = en_reply_in_thread;

/** @type {(inputs: Reply_In_ThreadInputs) => LocalizedString} */
const de_reply_in_thread = en_reply_in_thread;

/** @type {(inputs: Reply_In_ThreadInputs) => LocalizedString} */
const ja_reply_in_thread = en_reply_in_thread;

/** @type {(inputs: Reply_In_ThreadInputs) => LocalizedString} */
const zh_reply_in_thread = en_reply_in_thread;

/** @type {(inputs: Reply_In_ThreadInputs) => LocalizedString} */
const ar_reply_in_thread = en_reply_in_thread;

/** @type {(inputs: Reply_In_ThreadInputs) => LocalizedString} */
const it_reply_in_thread = en_reply_in_thread;

/** @type {(inputs: Reply_In_ThreadInputs) => LocalizedString} */
const ru_reply_in_thread = en_reply_in_thread;

/** @type {(inputs: Reply_In_ThreadInputs) => LocalizedString} */
const pt_reply_in_thread = en_reply_in_thread;

/** @type {(inputs: Reply_In_ThreadInputs) => LocalizedString} */
const ko_reply_in_thread = en_reply_in_thread;

/**
* | output |
* | --- |
* | "Reply in thread..." |
*
* @param {Reply_In_ThreadInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const reply_in_thread = /** @type {((inputs?: Reply_In_ThreadInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reply_In_ThreadInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reply_in_thread(inputs)
	if (locale === "es") return es_reply_in_thread(inputs)
	if (locale === "fr") return fr_reply_in_thread(inputs)
	if (locale === "de") return de_reply_in_thread(inputs)
	if (locale === "ja") return ja_reply_in_thread(inputs)
	if (locale === "zh") return zh_reply_in_thread(inputs)
	if (locale === "ar") return ar_reply_in_thread(inputs)
	if (locale === "id") return id_reply_in_thread(inputs)
	if (locale === "it") return it_reply_in_thread(inputs)
	if (locale === "ru") return ru_reply_in_thread(inputs)
	if (locale === "pt") return pt_reply_in_thread(inputs)
	return ko_reply_in_thread(inputs)
});